export default "__VITE_ASSET__49d36567__"